import type { PopupType } from "../store/popupStore";
import { getMediaType } from "./mediaUtils";
import type { Entity, MediaResponse } from "../types";
import { hasValidGeometry } from "./geoUtils";
import type { SelectedEntity } from "../hooks/useSelectedEntity";

export const entityIsMedia = (entity: Entity) => {
  if (!entity) return false;
  const type = getMediaType(entity as unknown as MediaResponse);
  if (type === "unknown") return false;
  return true;
};

/**
 * Opting out 'mediaDetail' — it is manually triggered from the MediaDrawer.
 *
 * Now accepts `SelectedEntity` (the normalized shape from useSelectedEntity).
 * Uses `isDataLoaded` instead of the old `isComplete` flag.
 *
 * @deprecated Prefer setting popupType explicitly at the trigger point
 * (sidebar/map click) rather than inferring it from entity shape.
 * This utility is kept for backward compatibility during migration.
 */
export function resolveActiveModal(entity: SelectedEntity | null | undefined): PopupType | null {
  // Wait until L2 data is confirmed loaded before deciding modal type.
  // This prevents flashing the wrong modal during the initial fetch.
  if (!entity || !entity.isDataLoaded) return null;

  const isGeo = hasValidGeometry(entity);
  if (isGeo) return null;

  return entityIsMedia(entity) ? "media-viewer" : "non-geo-entity";
}
